import { Navigate } from "react-router-dom";
import { can, type AdminSection } from "@podecontratar/shared/lib/admin-permissions";
import { useAdminRole } from "../AdminRoleContext";

/**
 * Route-level mirror of the server gate.
 *
 * Hiding a nav entry is not enough: typing the path directly would
 * otherwise mount a page whose every request 403s, which reads as a
 * broken screen instead of a permission boundary. Redirecting to the
 * dashboard is honest and always reachable — `overview` is the one
 * section every role has.
 */
export function RequireSection({
  section,
  children,
}: {
  section: AdminSection;
  children: React.ReactNode;
}) {
  const role = useAdminRole();
  if (!can(role, section)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
